export default class DirectoryClient {
    static service = 'file-system.directory';
    apiClient;
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    create(params) {
        const endpoint = this.makeEndpoint('create');
        return this.apiClient.exec(endpoint, params);
    }
    createIfNotExists(params) {
        const endpoint = this.makeEndpoint('create-if-not-exists');
        return this.apiClient.exec(endpoint, params);
    }
    update(params) {
        const endpoint = this.makeEndpoint('update');
        return this.apiClient.exec(endpoint, params);
    }
    size(params) {
        const endpoint = this.makeEndpoint('size');
        return this.apiClient.exec(endpoint, params);
    }
    listDir(params) {
        const endpoint = this.makeEndpoint('list-dir');
        return this.apiClient.exec(endpoint, params);
    }
    makeEndpoint(operation) {
        return `${DirectoryClient.service}/${operation}`;
    }
}
